<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 只有 ID== 318 的财务可以添加维修商-->
        <el-form-item v-if="user.user_group_id == 2 && user.id == 318"  class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
        <el-form-item  v-else-if="user && [1].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn" v-if="user && [1, 2, 3, 4].includes(user.user_group_id)">
          <el-button type="primary" icon="el-icon-download" @click="Export(`维修商列表`)">导出</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"></Table>

    <FormDialog ref="dialog" :title="title" :labelWidth="'110px'" :width="'548px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'repair',
      getListUrl: 'maunitrec',
      breadcrumb: [
        { name: "维保管理", path: `/fix/repairer` },
        { name: "维修商管理", path: `/fix/repairer` },
      ],
      formCtrl: [
        {
          label: "维修商名称",
          keyName: "name",
          placeholder: "请填写维修商名称",
          type: "text",
        },
      ],
      cols: [
        { prop: "maunit", label: "维修商名称" },
        { prop: "address", label: "地址" },
        { prop: "name", label: "联系人" },
        { prop: "tel", label: "联系电话" },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: (data) => {
            this.title = '查看'
            this.viewMode = true
            this.getItem(data);
          },
        },
        {
          ...this.editBtn,
          cb: (data) => {
            this.title = '编辑'
            this.viewMode = false
            this.getItem(data);
            this.mformCtrl.map(c => {
              if (c.keyName == 'username') {
                c.disabled = true
              }
            })
            this.$forceUpdate()
          },
        },
        // {
        //   ...this.delBtn,
        //   cb: ({ id }) => {
        //     this.delete(id)
        //   },
        // },
        {
          title: '打款记录',
          img: require('@/assets/img/shipper_order_list.png'),
          unimg: require('@/assets/img/shipper_order_list_hover.png'),
          cb: ({ id, maunit }) => {
            this.$router.push(
              `/fix/payment?id=${id}&name=${maunit}`
            );
          },
        },
      ],
      title: '添加',
      viewMode: false,
      mform: {},
      mrules: {
        maunit: [
          {
            required: true,
            message: '请填写维修商名称',
            trigger: 'blur',
          }
        ],
        address: [
          {
            required: true,
            message: '请填写地址',
            trigger: 'blur',
          }
        ],
        name: [
          {
            required: true,
            message: '请填写联系人',
            trigger: 'blur',
          }
        ],
        tel: [
          {
            required: true,
            validator: this.checkPhone,
            trigger: "blur"
          },
        ],
        username: [
          {
            required: true,
            message: '请填写账号',
            trigger: 'blur',
          }
        ],
        password: [
          { required: true, message: "请填写密码", trigger: "blur" },
          { min: 6, message: "长度不小于 6 位", trigger: "blur" },
        ],
      },
      mformCtrl: [
        {
          label: "维修商名称",
          keyName: "maunit",
          err: "请填写维修商名称",
          type: "text",
        },
        {
          label: "地址",
          keyName: "address",
          err: "请填写地址",
          type: "text",
        },
        {
          label: "联系人",
          keyName: "name",
          err: "请填写联系人",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "tel",
          err: "请填写联系电话",
          type: "text",
        },
        {
          label: "账号",
          keyName: "username",
          err: "请填写账号",
          type: "text",
        },
        {
          label: "密码",
          keyName: "password",
          err: "请填写密码",
          type: "password",
        },
      ],
      modalSubmitUrl: 'addmaunit',
    };
  },
  methods: {
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          params[key] = value;
        }
      }

      const opt = params.id ? 'update' : 'create'

      params['headers'] = {
        'X-Method': opt,
        'X-Module': 'repair_shop',
      }
    },

    addItem() {
      this.title = '添加'
      this.viewMode = false
      this.mform = {
        maunit: '',
        address: '',
        name: '',
        tel: '',
        username: '',
        password: '',
      }
      this.mformCtrl.map(c => {
        if (c.keyName == 'username') {
          c.disabled = false
        }
      })
      this.$forceUpdate()
      console.log('表单', { ...this.mform })
      this.showDialog();
    },
    getItem({ id }) {
      this.loading = true;
      let url = `${this.baseUrl}/maunititem`;
      const params = {
        // userid: this.user.id,
        id,
      };
      this.post(
        url,
        params,
        (res) => {
          const { msg, data } = res;
          if (msg === "success" && data) {
            // console.log(data);
            this.mformCtrl.map((v) => {
              const key = v.keyName;
              this.mform[key] = data[key];
            });
            this.mform['id'] = id
            this.$forceUpdate()
            this.showDialog();
          } else {
            this.$message({
              type: "error",
              message: "加载失败，请稍后再试！",
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
  },
  mounted() {
    const { user_group_id } = this.user
    if (![1, 2, 3, 4, 5].includes(user_group_id)) {
      this.btns.length = 1
    }
  },
};
</script>

<style lang="less" scoped></style>
